import { useCallback } from 'react'

import { useSideBySideChartContext } from '../../contexts/side-by-side.context'
import { REGIONS } from './constants'
import { NcMap } from './nc-map'
import { UsMap } from './us-map'
import { GlobalMap } from './global-map'
import { ChartSizer } from '../../charts/common/chart-sizer'

export const MapChart = ({ region, width, ...props }) => {
  const sideBySideChartContext = useSideBySideChartContext() || {}

  const onZoomIn = useCallback((zoom) => {
    if (sideBySideChartContext.chartMirrorData) {
      sideBySideChartContext.setChartMirrorDataValue('zoom', zoom)
    }
  })

  const onZoomOut = useCallback(() => {
    if (sideBySideChartContext.chartMirrorData) {
      sideBySideChartContext.setChartMirrorDataValue('zoom', undefined)
    }
  })

  const RegionMap = getRegionComponent(region)

  return (
    <ChartSizer
      heightWidthRatio={0.5}
      heightViewportRatio={0.9}
      maxHeight={400}
    >
      {({ width, height }) => (
        <RegionMap
          zoomState={props.splitChart ? (sideBySideChartContext && sideBySideChartContext.chartMirrorData && sideBySideChartContext.chartMirrorData.zoom) : undefined}
          onZoomIn={props.splitChart && onZoomIn}
          onZoomOut={props.splitChart && onZoomOut}
          {...props}
          width={width}
        />
      )}
    </ChartSizer>)

  function getRegionComponent (region) {
    switch (region) {
      case REGIONS.NC:
        return NcMap
      case REGIONS.GLOBAL:
        return GlobalMap
      default:
        return UsMap
    }
  }
}
